import styled from 'styled-components'
import { theme } from '@/client/components'

const { color, breakpoint, font, space } = theme

export const Masonry = styled.div<{
  gap: number
}>`
  display: flex;

  align-items: flex-start;

  gap: ${({ gap }) => `${gap}px`};

  overflow: visible;
`

export const Column = styled.div<{
  gap: number
}>`
  flex: 1;

  display: flex;

  flex-direction: column;

  gap: ${({ gap }) => `${gap}px`};

  position: relative;

  overflow: visible;
`

export const ImageInfos = styled.div<{
  isLastColumn?: boolean
}>`
  position: absolute;
  top: 20px;
  padding: ${space.lg};
  background-color: ${color.grayscale.black};
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
  max-width: min(320px, 80vw);
  width: 100%;
  word-break: break-word;

  ${({ isLastColumn }) =>
    isLastColumn
      ? `
        right: calc(100% + 20px);

        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      `
      : `
        left: calc(100% + 20px);

        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      `}

  @media (max-width: ${breakpoint.lg}) {
    top: 0;
    left: 0;
    right: 0;
    width: auto;
    max-width: 100%;
    border-radius: 10px;
  }
`

export const ImageWrapper = styled.div<{ width?: number; height?: number }>`
  position: relative;
  &:hover .image-infos {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    z-index: 9;
  }

  img {
    position: relative;
    z-index: 1;
    display: block;
  }
`

export const ImageInfosRectangle = styled.div<{
  isLastColumn?: boolean
}>`
  display: none;

  @media (min-width: ${breakpoint.lg}) {
    position: absolute;

    display: block;

    z-index: 1001;

    top: 0;

    ${({ isLastColumn }) =>
      isLastColumn
        ? `
          right: -20px;
        `
        : `
          left: -20px;
        `}

    width: 20px;

    height: calc(100% - 20px);

    background-color: ${color.grayscale.black};

    &::before,
    &::after {
      content: '';

      position: absolute;

      display: block;

      width: 0;

      height: 0;

      border-style: solid;
    }

    &::before {
      top: -20px;

      ${({ isLastColumn }) =>
        isLastColumn
          ? `
            right: 0;

            border-width: 0 0 20px 20px;

            border-color:
              transparent
              transparent
              ${color.grayscale.black}
              transparent;
          `
          : `
            left: 0;

            border-width: 20px 0 0 20px;

            border-color:
              transparent
              transparent
              transparent
              ${color.grayscale.black};
          `}
    }

    &::after {
      bottom: -20px;

      ${({ isLastColumn }) =>
        isLastColumn
          ? `
            right: 0;

            border-width: 20px 20px 0 0;

            border-color:
              ${color.grayscale.black}
              transparent
              transparent
              transparent;
          `
          : `
            left: 0;

            border-width: 0 20px 20px 0;

            border-color:
              transparent
              ${color.grayscale.black}
              transparent
              transparent;
          `}
    }
  }
`

export const InfoTitle = styled.p`
  color: ${color.text.inverse};

  font-family: ${font.family.heading};

  font-size: ${font.size.h5max};

  font-weight: ${font.weight.bold};

  margin-bottom: ${space.sm};
`

export const InfoDescription = styled.p`
  color: ${color.text.inverse};

  font-size: ${font.size.root};

  line-height: ${font.lineHeight.md};
`

export const Skeleton = styled.div`
  position: absolute;
  inset: 0;

  background: #eee;

  z-index: 0;
`
